import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Motion";
import { SERVICES } from "@/data/site";

const SPANS = [
  "lg:col-span-7 lg:row-span-2",
  "lg:col-span-5",
  "lg:col-span-5",
  "lg:col-span-6",
  "lg:col-span-6",
];

const Card = ({ s, span, i }) => (
  <Reveal delay={i * 0.08} className={`h-[400px] sm:h-[460px] lg:h-auto ${span}`}>
    <Link
      to={`/servicos/${s.slug}`}
      data-testid={`bento-card-${s.slug}`}
      className="group relative block h-full overflow-hidden border border-white/10 bg-[#111318]"
    >
      <img src={s.card ?? s.hero} alt={s.name} style={{ objectPosition: s.card ? "50% 50%" : s.heroPos ?? "50% 50%" }} className="absolute inset-0 h-full w-full object-cover grayscale-[35%] transition-[transform,filter] duration-[1200ms] ease-out group-hover:scale-110 group-hover:grayscale-0" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-black/10" />
      <div className="absolute left-6 top-6 font-mono text-xs tracking-[0.25em] text-[#C8D484]">{s.index}</div>
      <span className="absolute right-6 top-6 grid h-12 w-12 place-items-center rounded-full border border-white/30 bg-black/30 backdrop-blur-md transition-[background-color,transform] duration-500 group-hover:rotate-45 group-hover:bg-[#C8D484] group-hover:text-black">
        <ArrowUpRight className="h-5 w-5" />
      </span>
      <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
        <h3 className={`font-display font-semibold uppercase leading-[0.85] tracking-tight ${i === 0 ? "text-6xl sm:text-7xl lg:text-8xl" : "text-5xl sm:text-6xl"}`}>{s.name}</h3>
        <p className="mt-4 max-w-md text-sm text-white/80 sm:text-base">{s.short}</p>
      </div>
    </Link>
  </Reveal>
);

export const ServicesBento = () => (
  <section data-testid="services-bento" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 sm:py-32 lg:px-12">
    <div className="mb-14 grid gap-6 lg:grid-cols-12">
      <Reveal className="lg:col-span-7">
        <Eyebrow>Os nossos serviços</Eyebrow>
        <h2 className="mt-5 font-display text-5xl font-semibold uppercase leading-[0.85] tracking-tight sm:text-7xl lg:text-8xl">
          Tudo o que o seu cão precisa. <span className="font-serif font-normal normal-case italic tracking-normal text-[#C8D484]">num só sítio.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15} className="self-end lg:col-span-4 lg:col-start-9">
        <p className="text-white/75">Cinco serviços, uma equipa e o mesmo cuidado em tudo o que fazemos — da primeira aula de obediência ao banho antes de voltar para casa.</p>
      </Reveal>
    </div>
    <div className="grid grid-cols-1 gap-4 lg:auto-rows-[320px] lg:grid-cols-12">
      {SERVICES.map((s, i) => <Card key={s.slug} s={s} span={SPANS[i]} i={i} />)}
    </div>
  </section>
);
